<template>
  <!--
    Only a real photo (owner's rule O-1): no token, one that will not load, or not loaded yet → nothing at all — no
    initials, no placeholder icon. The name next to it says who it is.
  -->
  <img
    v-if="url"
    :src="url"
    :alt="t('support.manager.photoAlt', { name: name ?? '' })"
    :width="size"
    :height="size"
    class="manager-photo"
    data-testid="manager-photo"
    @error="url = null"
  >
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { operatorPhotoUrl } from '@/api/support';

const props = withDefaults(defineProps<{ token?: string | null; name?: string | null; size?: number }>(),
  { token: null, name: null, size: 40 });
const { t } = useI18n();
const url = ref<string | null>(null);

watch(() => props.token, async (token) => {
  url.value = null;
  if (!token) return;
  try {
    const loaded = await operatorPhotoUrl(token);
    if (props.token === token) url.value = loaded;   // the manager changed meanwhile → not this photo
  } catch {
    /* 404 (removed) or offline: nothing replaces it (REQ-041) */
  }
}, { immediate: true });
</script>

<style scoped>
.manager-photo { border-radius: 50%; object-fit: cover; flex: none; display: block; }
</style>
